module.exports = __webpack_public_path__ + "static/media/icon_bangkok.00920911.png";